import type { AccountState } from './interfaces';

export const initialState: AccountState = {
  loading: false,
  selectedAccount: null,
  accounts: {},
} satisfies AccountState as AccountState;
